import React from "react";
import { FiHome, FiMail, FiPhone, FiUsers, FiMessageCircle, FiSend, FiArrowRight } from "react-icons/fi";
import "./contact.css";

const contactCards = [
  {
    icon: <FiPhone />,
    title: "Sales inquiries",
    copy: "Talk to our team about solutions, pricing, and how we can help.",
    cta: "Contact sales",
  },
  {
    icon: <FiUsers />,
    title: "Partnership opportunities",
    copy: "Explore partnerships, alliances, and co-innovation.",
    cta: "Partner with us",
  },
  {
    icon: <FiHome />,
    title: "Product demos",
    copy: "See our platform in action with a personalized demo.",
    cta: "Request a demo",
  },
  {
    icon: <FiMessageCircle />,
    title: "General support",
    copy: "Get help with existing services and account support.",
    cta: "Get support",
  },
];

const Contact: React.FC = () => {
  return (
    <div className="contact-page">
      <section className="theme-hero">
        <div className="theme-hero-copy">
          <p className="theme-kicker">Contact</p>
          <h1>Let&apos;s build something meaningful together</h1>
          <p>
            Tell us about your goals and challenges. Our team can help with platform modernization,
            digital workflows, AI, discovery, payments, and operations.
          </p>
          <div className="theme-actions">
            <a href="#contact-form" className="theme-primary">
              Talk to us <FiArrowRight />
            </a>
            <a href="/products" className="theme-secondary">
              Explore products <FiArrowRight />
            </a>
          </div>
        </div>

        <div className="theme-hero-art theme-phone-scene" aria-hidden="true">
          <div className="home-visual-dots" />
          <div className="phone-frame phone-frame-back phone-back-left">
            <img src="/assets/hero/business-growth.png" alt="" style={{ objectPosition: "57% top" }} />
          </div>
          <div className="phone-frame phone-frame-back phone-back-right">
            <img src="/assets/hero/services.png" alt="" style={{ objectPosition: "67% top" }} />
          </div>
          <div className="phone-frame phone-frame-main">
            <img src="/assets/hero/requests.png" alt="" style={{ objectPosition: "65% top" }} />
          </div>
        </div>
      </section>

      <section className="contact-panel" id="contact-form">
        <div className="contact-panel-copy">
          <h2>Why Meet Us</h2>
          <ul>
            <li><strong>Innovation center:</strong> Experience applied AI and platform modernization demos.</li>
            <li><strong>Delivery excellence:</strong> Learn about our global delivery model and governance.</li>
            <li><strong>Security focus:</strong> Explore security-first approaches for critical programs.</li>
            <li><strong>Industry expertise:</strong> Discover sector-led solutions and outcomes.</li>
            <li><strong>Solution architects:</strong> Align on target-state architecture and integration strategy.</li>
            <li><strong>Rapid workshops:</strong> Identify priority use cases and build a 90-day execution plan.</li>
            <li><strong>Proof of value:</strong> Explore pilots that demonstrate measurable ROI quickly.</li>
          </ul>
        </div>

        <div className="contact-panel-form">
          <h2>Reach Out</h2>
          <form>
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <input type="text" placeholder="Organization" />
            <textarea rows={6} placeholder="Your Message" />
            <button type="submit">
              Send Message <FiSend />
            </button>
          </form>
          <p className="contact-note">
            We respect your privacy. Your information is secure and will only be used to respond
            to your inquiry.
          </p>
        </div>
      </section>

      <section className="contact-grid">
        {contactCards.map((card) => (
          <article className="contact-card" key={card.title}>
            <div className="contact-card-icon">{card.icon}</div>
            <h3>{card.title}</h3>
            <p>{card.copy}</p>
            <a href="/contact">{card.cta} <FiArrowRight /></a>
          </article>
        ))}
      </section>

      <section className="contact-cta">
        <div className="contact-cta-icon">
          <FiHome />
        </div>
        <div className="contact-cta-copy">
          <h3>Prefer a guided walkthrough? Book a discovery call.</h3>
          <p>Share your priorities and we&apos;ll map the right next steps for your business.</p>
        </div>
        <a href="/contact" className="theme-primary contact-cta-button">
          Book a discovery call <FiArrowRight />
        </a>
      </section>
    </div>
  );
};

export default Contact;
